var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUHlupa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_578",
    "data-name": "Grupo 578",
    xmlns: "http://www.w3.org/2000/svg",
    width: 153.545,
    height: 152.625,
    viewBox: "0 0 153.545 152.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_466",
    "data-name": "Grupo 466",
    transform: "translate(43.546 12.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_50",
    "data-name": "Elipse 50",
    cx: 49.722,
    cy: 49.722,
    r: 49.722,
    fill: "#dbdbdb"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_471",
    "data-name": "Grupo 471",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_467",
    "data-name": "Grupo 467",
    transform: "translate(46.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2300",
    "data-name": "Caminho 2300",
    d: "M220.094,203.194a53.715,53.715,0,1,1,53.716-53.715A53.777,53.777,0,0,1,220.094,203.194Zm0-102.839a49.123,49.123,0,1,0,49.123,49.123A49.179,49.179,0,0,0,220.094,100.355Z",
    transform: "translate(-166.378 -95.763)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_468",
    "data-name": "Grupo 468",
    transform: "translate(0 87.986)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_590",
    "data-name": "Ret\\xE2ngulo 590",
    width: 86.822,
    height: 4.592,
    transform: "translate(0 61.393) rotate(-45)",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_470",
    "data-name": "Grupo 470",
    transform: "translate(95.94 43.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_469",
    "data-name": "Grupo 469"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2301",
    "data-name": "Caminho 2301",
    d: "M284.773,161.492l-3.333,7.164c.112,1.128.171,2.276.171,3.431a35.438,35.438,0,0,1-32.586,35.282l-6.7,4.514c1.279.125,2.578.19,3.89.19a39.981,39.981,0,0,0,38.556-50.581Z",
    transform: "translate(-242.328 -161.492)",
    fill: "#161615"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUHlupa);
export default __webpack_public_path__ + "static/media/UHlupa.237bbd5c0b6c2c7d2b2a7d865b6f7bc3.svg";
export { ForwardRef as ReactComponent };